// 게임 → 렌더/UI/오디오 이벤트 링버퍼. 미리 할당한 슬롯을 재사용한다(프레임 루프 할당 금지).
// 소비자는 각자 커서(마지막으로 읽은 seq)를 들고 readFrom으로 읽는다.

export const Ev = {
  /** x,z 영웅 위치, a facing, b comboStep(0..3) 또는 10+skillId, c 반경, d 부채꼴 각, flags&1 마무리타 */
  Slash: 1,
  /**
   * x,y,z 타격점, a 데미지, b 대상(0 몹, 1 보스, 2 영웅), c 대상 인덱스, d 타격 방향(rad, facing 규약),
   * flags는 HitFlag 정본: 치명·마무리타·스킬·각성·다단·막힘·환경 피해.
   * 데미지 숫자는 이 이벤트에서만 띄운다(영웅 피격 b=2 포함).
   */
  Hit: 2,
  /** x,z 위치, a 몹 종류, b 몹 인덱스, c 날아가는 방향(rad), d 원인(0 기본, 1 스킬, 2 각성). flags & HitFlag.Environment는 환경 처치. 몹은 이 방향으로 튕겨 날아간다(DEATH_LAUNCH) */
  Kill: 3,
  /** a 처치 수(한 동작에 20+) */
  MassKill: 4,
  /** a 칭찬 단계(1..4), b 콤보 수 */
  ComboPraise: 5,
  /** a 히트스톱 틱 */
  Hitstop: 6,
  /** a 픽셀, b 감쇠 ms, c 방향 x, d 방향 z */
  CameraPunch: 7,
  /** a AwakenPhase */
  AwakenPhase: 8,
  /** x,z 중심, a 참격 번호(0..5), b 각도 */
  AwakenSlash: 9,
  /** x,z, a skillId, b facing */
  SkillCast: 10,
  /** x,z, a facing */
  Dodge: 11,
  /** x,z, a 데미지. HUD 비네트·초상 반응용(데미지 숫자는 Hit b=2) */
  HeroHurt: 12,
  /** a 웨이브 번호(0부터), b 마릿수 */
  WaveStart: 13,
  /** a 방 인덱스 */
  RoomEnter: 14,
  /** a 방 인덱스 */
  RoomClear: 15,
  /** a 문 인덱스, b 1=열림 0=닫힘 */
  Gate: 16,
  /** x,z 보스 위치 */
  BossIntro: 17,
  /** x,z */
  BossDefeated: 18,
  StageClear: 19,
  Defeat: 20,
  /** a SceneId */
  SceneChange: 21,
  /** x,z 몹 스폰 위치, a 몹 인덱스 */
  MobSpawn: 22,
  /**
   * x,z, a 텔레그래프 슬롯, b 모양, c 출처(TeleSource: 0 몹(멧돼지·엘리트), 1 보스, 2 분출구, 3 주술사),
   * d 출처 번호(몹 인덱스 / 보스 BossKind / map.vents 인덱스). 오디오·VFX가 주인을 추측하지 않게 한다(2026-10-15 parent 요청).
   */
  TelegraphFire: 23,
  /** 결투장식 KO(결정타). x,z 대상 위치, a 종류(0 엘리트, 1 방의 마지막 몹, 2 보스). 세계는 KO.slowTicks 동안 느려진다 */
  Ko: 24,
  /** x,z 위치, a 대상(0 몹, 1 보스), b 몹 인덱스(보스는 0), c 무방비 길이 틱 */
  GuardBreak: 25,
  /** x,z 영웅 위치, a 슬로 틱, b 피한 공격 출처(0 몹, 1 보스, 2 경고 데칼) */
  JustDodge: 26,
  /** x,z 영웅 위치, a 회복량, b 원인(0 방 정리, 1 처형) */
  HeroHeal: 27,
  /** NPC·장비 창. a 1 열림 0 닫힘, b NPC 인덱스(장비 창은 -1) */
  Menu: 28,
  /** 거래·장착 결과. a 1 성공 0 실패, b TxKind 번호(1 buy, 2 equip, 3 focus, 4 recover). 문구는 GameView.profile.last */
  Trade: 29,
  /**
   * R2 용암 분출구 분출(경고 원이 끝나는 틱). x,z 중심, a 분출구 인덱스(map.vents), b 반경, c 1 = 영웅 적중.
   * 경고 시작은 TelegraphSlot(Circle)으로만 보인다(분출구 위치 = 경고 원 중심).
   */
  HazardErupt: 30,
  /** 용암 웅덩이 화상. x,z 영웅 위치, a 피해. 경직 없음(데미지 숫자는 Hit b=2) */
  LavaBurn: 31,
  /**
   * 보스 패턴 시작(경고가 나타나는 틱). x,z 보스, a 패턴(0 내려찍기·화염 고리, 1 휩쓸기·균열, 2 운석 연속, 3 소환), b BossKind.
   * 오디오·HUD 큐 요청용(docs/HUNT-R2-AUDIO-CUES.md). 기존 고목 수호자도 같은 이벤트를 낸다.
   */
  BossPattern: 32,
  /** 주술사 포격 시작. x,z 목표 중심, a 몹 인덱스, b 반경 */
  ShamanCast: 33,
  /** R2 용암 분출구 경고 시작(경고 원이 생기는 틱, 한 번). x,z 중심, a 분출구 인덱스, b 반경, c 경고 길이(틱) */
  HazardWarn: 34,
  /** 스킬 캔슬(LINK). x,z 영웅 위치, a 끊긴 skillId, b 새 skillId */
  SkillCancel: 35,
  /** 연계 단계 상승(2 이상일 때만). x,z 영웅 위치, a 새 단계(2..3), b 그 단계를 연 skillId, c 스킬 피해 배율 */
  LinkUp: 36,
  /** 연계 3단 피니시(LinkUp a=3과 같은 틱, 그 뒤에 나온다). x,z 영웅 위치, a 이번 판 피니시 횟수, b 더한 각성 게이지(0..1) */
  LinkFinish: 37,
  /**
   * 스킬 트리 추가 효과의 판정 순간(docs/SKILL-TREE.md, growth.ts BurstKind). x,z 중심(선분형은 시작점), a BurstKind,
   * b 반경(원형) 또는 길이(선분형, m), c 방향(rad, facing 규약), d 선분 폭(m, 원형 0). 피해는 같은 틱 Ev.Hit로 따로 나온다.
   */
  SkillBurst: 38,
  /** 레벨 업(던전 안에서도 즉시). x,z 영웅 위치, a 새 레벨, b 아직 쓰지 않은 스킬 포인트, c 이번에 오른 단계 수(한 번에 여러 단계면 2+) */
  LevelUp: 39,
  /** 스킬 트리 배우기·초기화 결과(마을). a 1 성공 0 실패, b 노드 인덱스(초기화 -1), c 새 랭크. 문구는 GameView.growth.last */
  SkillLearn: 40,
  /** 처치·클리어 EXP 획득. x,z 위치(클리어는 영웅), a 얻은 EXP, b 원인(0 처치, 1 보스, 2 클리어) */
  XpGain: 41,
  /** 공중 연타(COMBAT-FEEL 2.2): 뜬 몹을 다시 띄웠다. x,y,z 몹 위치, a 재띄우기 횟수(1..JUGGLE.maxRelaunch), b 몹 인덱스, c 새 체공 틱 */
  Juggle: 42,
  /**
   * 처형(COMBAT-FEEL 2.4): 무방비 몹을 한 번에 쓰러뜨렸다(Hit·Kill 이벤트가 같이 난다). x,y,z 몹 위치, a 몹 종류, b 몹 인덱스,
   * c 회복량(보상을 못 받으면 0), d 타격 방향, flags & 1 = 이 처형이 보상(회복·각성·카메라)을 받음
   */
  Execute: 43,
  /** 연속 처치 사슬이 이어졌다(처치마다, COMBAT-FEEL 2.5). x,z 처치 위치, a 사슬 수, b 사슬 창 틱, c 다음 단계까지 남은 처치 수 */
  KillChain: 44,
  /** 연속 처치 단계 달성(사슬이 RAMPAGE.every의 배수). x,z 영웅 위치, a 사슬 수, b 이번 판 단계 수, c 환급한 MP, d 이동 속도 효과 틱 */
  Rampage: 45,
  /** 몹이 다운에 들어갔다(COMBAT-FEEL 2.7). x,y,z 몹 위치, a 몹 인덱스, b 1 = 체공 상한으로 강제 다운, c 다운 틱 */
  MobDown: 46,
  /** 몹이 기상했다(다운이 끝나 무적 시작). x,y,z 몹 위치, a 몹 인덱스, b 무적 틱 */
  MobWake: 47,
  /**
   * 스킬 타임라인 큐(COMBAT-FEEL 2.10): 그 틱에 실행되는 VFX·SFX·카메라 큐. x,y,z 그 틱의 영웅 위치(y = 높이, 렌더가 큐 연출을 그 높이에 띄운다), a skillId, b 채널(0 vfx, 1 sfx, 2 camera),
   * c 그 스킬 cues 배열 안의 번호, d facing. 이름은 shared/skills/<hero>.ts의 cues[c].name이다(렌더·오디오가 이름으로 고른다, 연결은 최소).
   * c022: 표는 지금 영웅의 것(GameView.heroId → skills/registry heroSkills). flags & 1 = 세계 위치 큐(cue.at 'world': 장판 놓기·다단·덫 발동·폭발 착탄),
   * 이때 x,y,z는 그 세계 지점(y 0)이고 영웅 위치가 아니다. flags & 2 = 카엘 전직 갈래 1(소드 마스터, C10-5) — 9·10번 큐는 그 갈래 표(KAEL_SKILLS_BY_JOB[1])로 찾는다.
   */
  SkillCue: 48,
  /**
   * 레벨업으로 새 스킬을 자동 습득했다(D1e, docs/SKILL-TREE.md 11.2). 레벨업 순간에만 나며(로드·마을 진입으로 이미 가진 스킬은 아님) LevelUp 바로 뒤에 난다.
   * x,z 영웅 위치, a 새 스킬 번호(1..5), b 영웅 레벨, c 그다음 새 스킬 레벨(없으면 0). 시연 컷 훅.
   */
  SkillLearned: 49,
  /**
   * 바닥 드롭(D2a). x,z 떨어진 자리, a 종류(0 장비, 1 강화석), b 등급 번호(0 일반 1 희귀 2 영웅 3 세트 4 전설, 강화석 0),
   * c 드롭 풀 슬롯(GameView.loot), d 1 = 보스 확정 드롭, flags & 1 = 이름 있는 유니크(BALANCE-1028 3절 — 렌더는 주황 빛기둥 + 내리꽂힘 연출, b는 영웅 등급 그대로). 렌더는 등급 색 빛기둥, 오디오는 등급별 떨어짐 소리(전설·세트 강조)
   */
  LootDrop: 50,
  /**
   * 드롭 줍기(D2a). x,z 드롭 자리, a 종류, b 등급 번호, c 방법(0 영웅, 1 동행 펫, 2 클리어 수거, 3 풀 넘침),
   * d 강화석이면 개수, 장비면 부위 번호(gearLedger.SLOT_ORDER: 0 무기 1 투구 2 갑옷 3 장갑 4 신발 5 목걸이), flags & 1 = 가방이 가득 차 바로 정리됨, 장비면 flags & 2 = 이름 있는 유니크(주황 줍기 연출).
   * 드롭 식별: y = 장비면 GameView.loot.picked 고리 칸 + 1(그 칸의 GearItem이 이름·그림·비교 기준, 0 = 없음 — 칸 0과 겹치지 않게 1부터), 강화석이면 flags >> 1 = 강화석 등급(0..3).
   * HUD는 화면 가장자리 띠로만 알린다
   */
  LootPickup: 51,
  /**
   * 강화 결과(D2b, 마을 대장간). a 결과(0 성공, 1 유지, 2 하락, 3 보호 주문서로 막음), b 새 단계, c 이전 단계, d 실효 확률(0..1).
   * VFX 훅: 성공 섬광·실패 불씨는 아직 없다(VFX 레인 TODO) — 지금은 UI 결과 띠와 효과음만
   */
  GearEnhance: 52,
  /**
   * 장비 명령 결과(장착·벗기·정리·주문서 구매·강화). a 1 성공 0 실패, b 종류(1 장착 2 벗기 3 강화 4 정리 5 주문서 6 손상 복구,
   * 7 구매 8 제작 9 비약 10 박기 11 빼기 12 합성 — D2c, 13 마을 장비 구매 — S7). 문구는 GameView.gear.last
   */
  GearCmd: 53,
  /**
   * 전설 고유 효과 발동(PR #154 Codex 2차 P1, VFX 훅 — 연출은 VFX 레인 TODO). x,z 영웅 위치(처치 효과는 처치 자리),
   * a 효과 번호(content/items LEGEND_UNIQUES 순서), b 양(회복량·보호막·감소 틱·MP·각성 ×1000)
   */
  GearUnique: 54,
  /**
   * 장비 알림(c015): 이미 성공이라 알린 연산이 저장소 최신 기준(다른 탭 변경) 위에서 다시 적용될 때 거절됐다. a 마지막 종류(GearCmd b와 같은 번호, 7 줍기), b 이번에 거절된 건수,
   * 문구는 GameView.gear.notice. HUD 가장자리 띠로 알린다(조용히 사라지지 않게)
   */
  GearNotice: 55,
  /** 스테이지 결과(D3a). a 지역 번호, b 스테이지 번호, c 1 = 첫 클리어(해금 상승), d 예약된 다음 마을(0 = 없음) */
  StageResult: 56,
  /** 마을 이동 연출 시작(D3a: n-10 첫 클리어 뒤 귀환·워프). a 도착 마을, b 떠난 마을, c 연출 틱 */
  Travel: 57,
  /** 잠긴 지역 문 앞(D3a). a 잠긴 지역 번호 */
  StageLocked: 58,
  /**
   * 정예 지역 효과·중독(D3a). a 1 = 서리(둔화 시작), 2 = 중독(시작), 3 = 중독 피해 틱. x,z 영웅 위치, b 남은 틱(1·2) 또는 피해(3)
   */
  HeroStatus: 59,
  /**
   * 소비 아이템 사용(D2c). x,z 영웅 위치. a 종류(ConsumeKind: 0 HP 물약, 1 MP 물약, 2 비약, 3 귀환서, 4 부활 깃털),
   * b 물약 회복량(HP·MP 정수) · 비약 번호(ELIXIRS 순서) · 부활 HP, c 물약 크기(0 소 1 중 2 대) · 비약 새 남은 초, d 물약 감쇠 배율(0..1).
   * 효과음 훅(오디오 레인): 물약 마시기·비약·깃털. VFX: 영웅 발밑 작은 회복 고리(섬광 없음, 섬광 약화 존중)
   */
  Consume: 60,
  /** 물약 버튼을 눌렀지만 쓰지 못함(D2c). a 이유(0 쿨다운, 1 물약 없음, 2 이미 가득), b 퀵슬롯(0 HP, 1 MP), c 남은 쿨다운 틱. UI 버튼 거부 흔들림·효과음 훅 */
  ConsumeDenied: 61,
  /** 비약이 다 됐다(D2c, 플레이 시계 기준). a 비약 번호(ELIXIRS 순서). HUD 가장자리 아이콘이 사라진다 */
  ElixirEnd: 62,
  /**
   * 화살 발사(c022 라이라, game/arrows.ts). 화살 한 발마다 한 건. x,y,z 발사 위치(y = 발사 높이 m), a 방향(rad, facing 규약 atan2(dx, dz)),
   * b 속도(m/s, 영웅 시간), c 사거리(m), d 종류(skills/types ArrowKind: 0 기본 lyra_shot · 1 강사 lyra_shot_heavy · 2 관통 lyra_pierce · 3 폭발 ·
   * 4 공중 lyra_air_volley · 5 유도 lyra_homing · 6 올려쏘기 lyra_launch_shot · 7 회오리).
   * flags & 1 = 관통, & 2 = 스킬 화살(아니면 기본 공격), flags >> 8 = 화살 슬롯(0..ARROW_SLOTS-1, Ev.ArrowEnd와 짝).
   * 소리: 기본 공격 화살은 이 이벤트로 bow_release(종류 1이면 bow_release_heavy)를 낸다. 스킬 화살 소리는 스킬 큐(Ev.SkillCue)가 낸다
   */
  Arrow: 63,
  /** 화살이 끝났다(c022). x,z 끝 위치, a 화살 슬롯, b 이유(0 사거리 끝, 1 적중해 멈춤, 2 벽), c 종류(ArrowKind) */
  ArrowEnd: 64,
  /** 영웅 선택 결과(c022, 마을). a 1 성공 0 실패, b 영웅 번호(0 카엘, 1 라이라), c 실패 이유(0 없음, 1 마을 아님, 2 모르는 영웅, 3 이미 그 영웅) */
  HeroSelect: 65,
  /** 몹 속박(c022 그물 덫). x,z 몹 위치, a 몹 인덱스, b 속박 틱(0 = 저항), c 1 = 보스 */
  MobRoot: 66,
  /** 스타일 랭크 승급(COMBAT-FEEL 2.14). x,z 영웅 위치, a 새 등급(1..STYLE_RANK.letters.length), b 그때 사슬 수. 하강(사슬 끊김)은 이벤트 없이 view.rampage.rank가 0이 된다 */
  StyleRank: 67,
  /** 레이드 용병(RAID-PRD 3절). x,z 용병 위치, a 용병 칸(0 방패병, 1 궁수, 2 사제), b game/raid MercEvent(0 공격, 1 치유, 2 도발, 3 쓰러짐, 4 일어남, 5 피격, 6 피하기), c 값(피해·치유 대상·도발 틱), d 치유량 */
  RaidMerc: 68,
  /** 레이드 불 장판이 생겼다. x,z 자리, a 반경, b 남는 틱 */
  RaidFire: 69,
  /** 레이드 입장 거절. a 이유(1 마을② 전, 2 모르는 레이드, 3 장면·창 아님) */
  RaidDenied: 70,
  /** 일일 의뢰 수령(L9). a 1 성공·0 거절, b 받은 골드 */
  DailyClaim: 71,
  /** 일일 던전·탑 입장 결과(L9). a 1 입장·0 거절, b 종류(0 보물고, 1 광산, 2 탑), c 거절 이유(daily.ts DailyCode 순번: 0 없음) */
  DailyEnter: 72,
  // 용사의 시련(3개월 C7, game/trialRun.ts). 다른 덩어리가 73번부터 쓸 수 있어 90번대를 쓴다
  /** 시련 입장 결과. a 1 입장·0 거절, b 시련 순번(content/trials TRIALS, 모르면 -1), c 거절 이유(trialRun TRIAL_DENY, 0 없음) */
  TrialEnter: 90,
  /** 시련 판 끝. a trialRun TRIAL_OUTCOME(0 실패·1 조건 미달·2 이룸·3 이미 이룸), b 1 = 지급 저장 재시도 중, c 시련 순번 */
  TrialResult: 91,
  /** 시련 상자 열기. a 시련판 순번(TRIAL_BOARDS), b 1 = 지급 저장 재시도 중, c 골드, d 강화석 */
  TrialChest: 92,
  /**
   * 헬 보스 「지옥불 각인」(C10, game/hellBrand.ts). x,z 각인 자리, a HellBrandPhase(0 새김 = 경고 시작, 1 폭발 + 장판),
   * b 반경, 새김: c 경고 틱·d 1 광폭 간격 / 폭발: c 1 영웅이 맞음
   */
  HellBrand: 93,
  /** 전직(C10-5, game/jobRun.ts). a 단계(1 전직 I 갈래 선택·2 전직 II 승급), b 갈래(0 블러드 버서커·1 소드 마스터), c 1 = 성공 · 0 거절(d 거절 이유 JOB_DENY) */
  JobChange: 94,
} as const;
/** Ev.Consume a 값 */
export const ConsumeKind = { HpPotion: 0, MpPotion: 1, Elixir: 2, ReturnScroll: 3, Feather: 4 } as const;
export type EvType = (typeof Ev)[keyof typeof Ev];

/** Hit 효과 비트의 단일 정본. Environment는 Hit·Kill 공통이며 전투/보상 원인(d)을 바꾸지 않는다. Juggle: 공중에 뜬 몹에 들어간 타격(+15%). Execute: 처형 타격(Hit·Kill 공통). DownChase: 다운 중인 몹에 들어간 추격 타격(피해 60%, COMBAT-FEEL 2.7). Launch: 런처가 띄우기를 시도한 타격(엘리트 저항으로 못 띄울 수 있다, COMBAT-FEEL 2.11). */
export const HitFlag = { Crit: 1, Finisher: 2, Skill: 4, Awaken: 8, MultiHit: 16, Blocked: 32, Environment: 64, Juggle: 128, Execute: 256, DownChase: 512, Launch: 1024, Arrow: 2048, Pierce: 4096, Ally: 8192 } as const;
/** HitFlag.Ally(레이드): 용병이 보스를 친 타격(b = 1, c = 용병 칸 1..3) 또는 용병이 맞은 피해(b = 3, c = 용병 칸 0..2). 영웅 콤보·각성·피해 합계에 넣지 않는다 */
/** HitFlag.Arrow(c022): 화살이 맞힌 타격(소리 arrow_hit), Pierce: 관통 화살의 타격(소리 arrow_pierce). 장판·폭발 피해에는 붙지 않는다 */

/** Ev.TelegraphFire.c 출처 표지 */
/** HellBrand 4: 헬 보스 판 「지옥불 각인」(game/hellBrand.ts, d = 0) */
export const TeleSource = { Mob: 0, Boss: 1, Vent: 2, Shaman: 3, HellBrand: 4 } as const;
export type TeleSourceId = (typeof TeleSource)[keyof typeof TeleSource];

export interface GameEvent {
  type: number;
  /** 이벤트가 생긴 시뮬레이션 틱 */
  tick: number;
  x: number;
  y: number;
  z: number;
  a: number;
  b: number;
  c: number;
  d: number;
  flags: number;
}

export class EventQueue {
  readonly capacity: number;
  private readonly slots: GameEvent[];
  /** 지금까지 쓴 이벤트 수(단조 증가). 다음 seq와 같다. */
  written = 0;

  constructor(capacity = 1024) {
    this.capacity = capacity;
    this.slots = new Array<GameEvent>(capacity);
    for (let i = 0; i < capacity; i++) {
      this.slots[i] = { type: 0, tick: 0, x: 0, y: 0, z: 0, a: 0, b: 0, c: 0, d: 0, flags: 0 };
    }
  }

  /** 새 슬롯을 0으로 초기화해 돌려준다. 호출자가 필드를 채운다. */
  push(type: number, tick: number): GameEvent {
    const e = this.slots[this.written % this.capacity];
    e.type = type;
    e.tick = tick;
    e.x = 0; e.y = 0; e.z = 0;
    e.a = 0; e.b = 0; e.c = 0; e.d = 0;
    e.flags = 0;
    this.written++;
    return e;
  }

  /**
   * cursor 이후 이벤트를 순서대로 넘기고 새 커서를 돌려준다.
   * 너무 오래 안 읽어 덮어쓴 이벤트는 건너뛴다.
   */
  readFrom(cursor: number, visit: (e: GameEvent) => void): number {
    let seq = cursor;
    if (seq > this.written) seq = this.written;
    if (this.written - seq > this.capacity) seq = this.written - this.capacity;
    for (; seq < this.written; seq++) visit(this.slots[seq % this.capacity]);
    return seq;
  }
}
